import get from 'lodash/fp/get';
import set from 'lodash/fp/set';
import getMatch from 'selectors/getMatch';
import contentRelationMap from 'config/types/content/relations';
import createGetContentItem, { getItemById } from './createGetContentItem';

export const getRelatedContentItemsByItem =
  (state, item) =>
    getRelatedContentItems(state, contentRelationMap, {
      type: get('metadata.type', item),
      metadata: get('metadata', item),
    });

export const getPostRelationsMap = (relationMap, match, data) => {
  const pathType = get('pathType', match);
  const contentType = data.type;

  return relationMap[contentType] || relationMap[pathType];
};

export function getRelatedContentItems(state, relationMap, data) {
  let related = {};
  if (!data) {
    return related;
  }

  const relations = getPostRelationsMap(relationMap, getMatch(state), data);
  if (!relations) {
    return related;
  }

  Object.keys(relations).forEach((path) => {
    const { path: setPath, contentType } = relations[path];
    const ids = get(`metadata.${path}`, data) || [];
    const getItem = contentType ?
      createGetContentItem(contentType) :
      getItemById;

    const items = ids
      .map((id) => getItem(state, id))
      .filter((relatedItem) => !!relatedItem) || [];

    related = set(setPath, items, related);
  });

  return related;
}
